import { create } from 'zustand';

type CommandPaletteState = {
  isOpen: boolean;
  open(): void;
  close(): void;
  toggle(): void;
  setOpen(isOpen: boolean): void;
};

const useCommandPaletteState = create<CommandPaletteState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpen: (isOpen) => set({ isOpen }),
}));

export default useCommandPaletteState;
